import * as auth from './auth'
import * as dataReport from './dataReport'

export default {
  ...auth,
  ...dataReport
}
